<template>
  <v-layout>
    <MainMenu />
    <v-layout column>
      <v-layout class="none-growth">
        <v-flex>
          <listPagesHeader
            :page-title="pageTitle"
            :show-btn="false"
          />
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="page-content-paddings">
          <v-layout
            class="list-header"
            wrap
          >
            <v-flex xs12>
              <h2 class="d-inline-block">
                {{ $t('menu.families') }}
                <span v-if="!drafts.isLoading">({{ familiesToDecide.amount }})</span>
              </h2>
            </v-flex>
            <v-flex xs12>
              <p class="mt-2 mb-0">
                {{ $t('instructions.drafts') }}
              </p>
            </v-flex>
          </v-layout>
          <toBeIdentifiedAlikesFamiliesTable
            :items="familiesToDecide.data"
            :is-loading="drafts.isLoading"
            @reload="fetchFamiliesToDecide()"
          />
          <BasePagination
            :pagination="drafts.pagination"
            :amount-all="familiesToDecide.amount"
            @page="setDraftsPage"
            @amount="setDraftsItemsPerPage"
          />
        </v-flex>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import MainMenu from '@/components/widgets/menu/MainMenu';
import listPagesHeader from '@/components/widgets/lists/ListPagesHeader';
import toBeIdentifiedAlikesFamiliesTable from '@/components/widgets/families/ToBeIdentifiedAlikesFamiliesTable';
import BasePagination from '@/components/widgets/dataTable/BasePagination';

export default {
    name: 'FamiliesToDecidePage',
    components: {
        MainMenu,
        listPagesHeader,
        toBeIdentifiedAlikesFamiliesTable,
        BasePagination
    },
    beforeRouteLeave (to, from, next) {
        this.$store.commit('familyData/clearFormData');
        next();
    },
    data () {
        return {
            drafts: {
                isLoading: true,
                pagination: { page: 1, amount: 20, amountAll: 0 }
            }
        };
    },
    computed: {
        pageTitle () {
            return this.$t('alikes_table.title');
        },
        familiesToDecide () {
            return this.$store.getters['familyData/getFamiliesToDecide'];
        }
    },
    created () {
        this.fetchFamiliesToDecide();
    },
    methods: {
        fetchFamiliesToDecide () {
            this.drafts.isLoading = true;
            this.$store.commit('familyData/setFamiliesToDecide', []);
            this.$store
                .dispatch('familyData/getFamiliesToDecide', {
                    limit: this.drafts.pagination.amount,
                    offset: (this.drafts.pagination.page - 1) * this.drafts.pagination.amount
                })
                .then((data) => {
                    this.drafts.pagination.amountAll = this.familiesToDecide.amount;
                })
                .finally(() => {
                    this.drafts.isLoading = false;
                });
        },
        setDraftsItemsPerPage (event) {
            this.drafts.pagination.amount = event;
            this.drafts.pagination.page = 1;
            this.fetchFamiliesToDecide();
        },
        setDraftsPage (event) {
            this.drafts.pagination.page = event;
            this.fetchFamiliesToDecide();
        }
    }
};
</script>

<style scoped></style>
